module.exports = __webpack_public_path__ + "img/bannerepay.397eb63f.png";